module.exports = __webpack_public_path__ + "static/media/thanks_tara.8cbda12c.svg";